import { Injectable } from "@angular/core";
import { Params, Router, UrlSegment } from "@angular/router";
import { PreRenderService } from "../services/pre-render.service";
import { UrlSanitizerService } from "../services/url-sanitizer.service";

@Injectable()
export class UrlValidator {
  constructor(
    protected _urlSanitizerService: UrlSanitizerService,
    protected _router: Router,
    protected _preRenderService: PreRenderService
  ) {}

  /**
   * Checks if the url has issues and redirects if the url needed to be sanitized.
   * @param url the url segment array for the browser url
   * @returns false if the url as a string has any invalid conditions
   */
  isValidUrl(
    url: UrlSegment[],
    navigationQueryParams?: Params
  ): boolean {
    const fullUrl = url.join("/");
    const sanitizedUrl = this._urlSanitizerService.sanitizeUrl(fullUrl);

    if (fullUrl === sanitizedUrl) return true;

    this.navigationRedirect(
      sanitizedUrl,
      navigationQueryParams
    );
    return false;
  }

  /**
   * A 301 redirect when the initial url had some issue.
   * @param fallbackUrl the safe url to navigate to
   */
  navigationRedirect(
    fallbackUrl: string,
    navigationQueryParams?: Params
  ): void {
    this._router.navigate([`/${fallbackUrl}`], {
      queryParams: navigationQueryParams,
    });
    this._preRenderService.setPreRenderFlag(301, fallbackUrl, navigationQueryParams);
  }
}
